<script setup lang="ts">
import { computed, reactive } from 'vue';
import { placeholdersOf } from '../consentPlaceholders';
// Поля для подстановок {…} из шаблона согласий — например, цель обработки, разная для разных форм.
// Поле многострочное: в подстановку можно вставить целый текст с абзацами (однострочное поле склеивало строки).
const props = defineProps<{ consent: { text: string; fullText?: string } }>();
const emit = defineEmits<{ fill: [name: string, value: string] }>();
const names = computed(() => placeholdersOf(props.consent));
const braced = (name: string) => `{${name}}`;
// Подстановка внутри полного текста — обычно длинный текст с абзацами: поле сразу высокое, Enter — новая строка.
const inFullText = (name: string) => (props.consent.fullText ?? '').includes(braced(name));
const drafts = reactive<Record<string, string>>({});
// Пробелы и пустые строки по краям убираются, переносы внутри сохраняются (Windows-переносы приводятся к \n).
function apply(name: string) { const value = (drafts[name] ?? '').replace(/\r\n?/g, '\n').replace(/^\s+|\s+$/g, ''); if (value) { emit('fill', name, value); delete drafts[name]; } }
function onEnter(name: string, event: KeyboardEvent) {
  // В короткой подстановке Enter подставляет значение; Shift+Enter, Ctrl+Enter и подстановка в полном тексте — по правилам ниже.
  if (event.ctrlKey || event.metaKey) { event.preventDefault(); apply(name); return; }
  if (!inFullText(name) && !event.shiftKey) { event.preventDefault(); apply(name); }
}
</script>
<template>
  <div v-if="names.length" class="consent-placeholders">
    <p class="field-error">Заполните для этой формы — без этого форму нельзя опубликовать:</p>
    <div v-for="name in names" :key="name" class="placeholder-row" :class="{ multiline: inFullText(name) }">
      <label class="input-label">{{ braced(name) }}<textarea v-model="drafts[name]" class="control textarea compact placeholder-input" :rows="inFullText(name) ? 6 : 1" :placeholder="inFullText(name) ? 'Вставьте текст — абзацы и переносы строк сохранятся' : name.includes('китай') ? 'Например: 参加课程报名' : 'Например: записи на курс повышения квалификации'" @keydown.enter="onEnter(name, $event)"/></label>
      <button type="button" class="btn btn-quiet" :disabled="!(drafts[name] ?? '').trim()" @click="apply(name)">Подставить</button>
      <small v-if="inFullText(name)" class="field-help">Enter — новая строка, Ctrl+Enter — подставить.</small>
    </div>
  </div>
</template>
